import { Paper, List } from '@material-ui/core';
import IconButton from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import React from 'react';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import useTableButtonStyle from './TableButtonStyle';
import FileUploadButton from './actions-menu-buttons/FileUploadButton';
import DirectoryUploadButton from './actions-menu-buttons/DirectoryUploadButton';
import CreateDirectoryButton from './actions-menu-buttons/CreateDirectoryButton';

const DirectoryActionsMenu = (props) => {
    const { fileSystemNodePath } = props;
    const classes = useTableButtonStyle();
    const [anchorEl, setAnchorEl] = React.useState(null);
  
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
        setAnchorEl(null);
    };
  
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (<>
        <IconButton size="small" aria-label="delete" onClick={handleClick} className={classes.root}>
            <MoreVertIcon size="small"/>
        </IconButton>

        <Popover 
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            >
            <Paper>
            <List component="nav" aria-label="main mailbox folders">
                <FileUploadButton onClick={handleClose}/>
                <DirectoryUploadButton onClick={handleClose}/>
                <CreateDirectoryButton onClick={handleClose} fileSystemNodePath={fileSystemNodePath}/>
            </List>
            </Paper>
        </Popover>
    </>);
}

export default DirectoryActionsMenu;